import { IItemForGetShortInfo, TFileId, IServerError, IUserEmailValidationError, ICreateUser } from 'types';
import { createContext } from 'react';

export type TCreateUserSelectedItem = string | null;
export type TTypeOfCreateUserModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'fileSizeExceeded'
	| 'fileUploadError'
	| 'invalidFileFormat';
export type TSourceUrlLocally = Nullable<string>;

export interface ICreateUserState {
	fileId: TFileId;
	sourceUrlLocally: TSourceUrlLocally;
	name: string;
	surName: string;
	email: string;
	phoneNumber: string;
	fetchedRoles: IItemForGetShortInfo[];
	selectedRole: TCreateUserSelectedItem;
	fetchedCustomers: IItemForGetShortInfo[];
	selectedCustomer: TCreateUserSelectedItem;
	selectedCustomers: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	selectedRestaurants: string[];
	password: string;
	passwordConfirm: string;
	dataForSubmit: ICreateUser | null;
	typeOfModalWindow: TTypeOfCreateUserModalWindow;
	errorResponseData: IServerError<IUserEmailValidationError> | null;
}

export const createUserInitialState: ICreateUserState = {
	fileId: null,
	sourceUrlLocally: null,
	name: '',
	surName: '',
	email: '',
	phoneNumber: '',
	fetchedRoles: [],
	selectedRole: null,
	fetchedCustomers: [],
	selectedCustomer: null,
	selectedCustomers: [],
	fetchedRestaurants: [],
	selectedRestaurants: [],
	password: '',
	passwordConfirm: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface ICreateUserContext extends ICreateUserState {
	setFile(fileId: TFileId, sourceUrlLocally: TSourceUrlLocally): void;
	changeName(value: string): void;
	changeSurName(value: string): void;
	changeEmail(value: string): void;
	changePhoneNumber(value: string): void;
	setFetchedRoles(value: IItemForGetShortInfo[]): void;
	setRole(value: TCreateUserSelectedItem): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setCustomer(value: TCreateUserSelectedItem): void;
	setCustomers(value: string[]): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setRestaurants(value: string[]): void;
	changePassword(value: string): void;
	changePasswordConfirm(value: string): void;
	setDataForSubmit(value: ICreateUser | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateUserModalWindow): void;
	showErrorModalWithInfo(value: IServerError<IUserEmailValidationError> | null): void;
	resetFields(): void;
}

export const CreateUserContext = createContext<ICreateUserContext>({
	setFile: () => undefined,
	changeName: () => undefined,
	changeSurName: () => undefined,
	changeEmail: () => undefined,
	changePhoneNumber: () => undefined,
	setFetchedRoles: () => undefined,
	setRole: () => undefined,
	setFetchedCustomers: () => undefined,
	setCustomer: () => undefined,
	setCustomers: () => undefined,
	setFetchedRestaurants: () => undefined,
	setRestaurants: () => undefined,
	changePassword: () => undefined,
	changePasswordConfirm: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	resetFields: () => undefined,
	...createUserInitialState,
});
